import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { GetTicketViewBody } from '../models/ticket';

@Injectable({
    providedIn: 'root'
})

export class TicketService {
    constructor(private base: BaseService) { }

    getTickets(formData: FormData): Observable<ApiObjectData> {
        return this.base.heskMethod<ApiObjectData>('/ticket/getTickets/', formData);
    }

    viewTicketDetails(formData: FormData): Observable<ApiObjectData> {
        return this.base.heskMethod<ApiObjectData>('/ticket/view/', formData);
    }

    AddNewTicket(formData: FormData): Observable<ApiObjectData> {
        return this.base.heskMethod<ApiObjectData>('/ticket/add/', formData);
    }
}